import { Route } from "react-router-dom";
import { GiftScreen } from "./GiftScreen.tsx";

export const routes = <Route index path="gift-card/*" Component={GiftScreen} />;
